import type { ReactNode } from 'react';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl';
import type { FlagType } from '@atlassian/jira-servicedesk-common/src/model/flags';

export type Flag = {
	id: string | number;
	title: string;
	description: string | ReactNode;
	flagType: FlagType;
};

export type FlagData = {
	id: string | number;
	title: MessageDescriptor;
	description: MessageDescriptor | string;
	type: FlagType;
};

export type ArticleDraftState = {
	isDraftPublished: boolean;
	isDraftSavedWithUnpublishedChanges: boolean;
	isArticleSavedWithUnpublishedChanges: boolean;
	isArticleDeleted: boolean;
};
export type ConfluenceSpace = {
	spaceKey: string;
	spaceName: string;
};

export type SpacePermission = 'create_page' | 'read_space';

export type UserCapabilities = {
	hasConfluenceLicense: boolean;
	articleUserCapabilities: {
		canCreateArticle: boolean;
	};
	spaceUserCapabilities: {
		editableSpaces: ConfluenceSpace[];
		readableSpaces: ConfluenceSpace[];
	};
};

export type CategoryGuid = string;
export const categoryGuidToString = (guid: CategoryGuid): string => guid;
export const toCategoryGuid = (guid: string): CategoryGuid => guid;
export type Category = {
	id: CategoryGuid;
	name: string;
	description?: string;
	categoryUrl: string;
	lastUpdated: string | null;
	createdAt: string | null;
};

export type ArticleResponseType = {
	id: string;
	title: string;
	featuredInCategories: CategoryGuid[];
	categories: Category[];
	viewCount?: number;
	spaceId: number | undefined;
	spaceKey: string;
	lastModified: string;
	viewUrl: string;
	summaryExcerpt: string | undefined;
};

export type KnowledgeCommonFlagMessage = {
	articleDeletedFlagDescription: MessageDescriptor;
	articleDeletedFlagTitle: MessageDescriptor;
	confluenceCreatePageFailureDescription: MessageDescriptor;
	confluenceCreatePageFailureTitle: MessageDescriptor;
	articleSuccessSavedFlagDescription: MessageDescriptor;
	articleSuccessSavedFlagTitle: MessageDescriptor;
	draftSuccessSavedFlagTitle: MessageDescriptor;
	draftSuccessSavedFlagDescription?: MessageDescriptor;
	draftSuccessFlagDescription: MessageDescriptor;
	draftSuccessFlagTitle: MessageDescriptor;
};

export type ShowCreateArticleModalProps = {
	spaces: ConfluenceSpace[];
	topicId?: string;
	topicName?: string;
};
